import Brace from "backbone.brace";
import environment from "../common/environment";

const Model = Brace.Model.extend({
  namedAttributes: {
    type: String,
    endpoint: String,
    data: Object,
  },
  defaults: {
    type: "drilldown",
    endpoint: null,
    data: {},
  },
  getFinalEndpoint() {
    return environment.getApiHost() + this.getEndpoint();
  },
  /**
   * Assembles a final URL useful for configuring a model's endpoint.
   */
  getUrl() {
    let url = this.getFinalEndpoint();
    const data = this.getData();
    const params = data ? $.param(data) : null;

    if (params) {
      url = `${url}?${params}`;
    }

    return url;
  },
});

export { Model as default };
